import * as THREE from 'three';
import { extrudeSettings } from '../../../../../../../utils/Functions';

const PatternOneModel = ({ modelWidth, modelHeight, doorColor }) => {
    const pattern_1_model = () => {     
        const deviation = 0.05;
            
        const model = new THREE.Shape();
        model.moveTo(-(modelWidth / 2 + deviation), (modelHeight / 2 + deviation))
        model.lineTo(-(modelWidth / 2 + deviation), -(modelHeight / 2 + deviation))
        model.lineTo((modelWidth / 2 + deviation), -(modelHeight / 2 + deviation))
        model.lineTo((modelWidth / 2 + deviation), (modelHeight / 2 + deviation))
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-((modelWidth / 2 + deviation) - 0.001), ((modelHeight / 2 + deviation) - 0.001))
        hole.lineTo(-((modelWidth / 2 + deviation) - 0.001), -((modelHeight / 2 + deviation) - 0.001))
        hole.lineTo(((modelWidth / 2 + deviation) - 0.001), -((modelHeight / 2 + deviation) - 0.001))
        hole.lineTo(((modelWidth / 2 + deviation) - 0.001), ((modelHeight / 2 + deviation) - 0.001))
        hole.closePath();

        model.holes.push(hole);
        
        return model;
    }

    const pattern_2_model = () => {
        const deviation = 0.04;

        const model = new THREE.Shape();
        model.moveTo(-(modelWidth / 2 - deviation + 0.08), (modelHeight / 2 - deviation + 0.08))
        model.lineTo(-(modelWidth / 2 - deviation + 0.08), -(modelHeight / 2 - deviation + 0.08))
        model.lineTo((modelWidth / 2 - deviation + 0.08), -(modelHeight / 2 - deviation + 0.08))
        model.lineTo((modelWidth / 2 - deviation + 0.08), (modelHeight / 2 - deviation + 0.08))
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-(modelWidth / 2 - deviation), -(modelHeight / 2 - deviation))
        hole.lineTo(-(modelWidth / 2 - deviation), (modelHeight / 2 - deviation))
        hole.lineTo((modelWidth / 2 - deviation), (modelHeight / 2 - deviation))
        hole.lineTo((modelWidth / 2 - deviation), -(modelHeight / 2 - deviation))
        hole.closePath();

        model.holes.push(hole);
        
        return model;

    }

    const pattern_3_model = () => {
        const deviation = 0.05;

        const model = new THREE.Shape();
        model.moveTo(-(modelWidth / 2 - deviation), (modelHeight / 2 - deviation))
        model.lineTo(-(modelWidth / 2 - deviation), -(modelHeight / 2 - deviation))
        model.lineTo((modelWidth / 2 - deviation), -(modelHeight / 2 - deviation))
        model.lineTo((modelWidth / 2 - deviation), (modelHeight / 2 - deviation))
        model.closePath();

        return model;
    }

    const pattern_4_model = () => {
        const deviation = 0.13;

        const model = new THREE.Shape();
        model.moveTo(-(modelWidth / 2 - deviation), (modelHeight / 2 - deviation))
        model.lineTo(-(modelWidth / 2 - deviation), -(modelHeight / 2 - deviation))
        model.lineTo((modelWidth / 2 - deviation), -(modelHeight / 2 - deviation))
        model.lineTo((modelWidth / 2 - deviation), (modelHeight / 2 - deviation))
        model.closePath();

        return model;
    }

    const pattern_5_model = () => {
        const deviation = 0.13 + 0.05;

        const model = new THREE.Shape();
        model.moveTo(-(modelWidth / 2 - deviation), (modelHeight / 2 - deviation))
        model.lineTo(-(modelWidth / 2 - deviation), -(modelHeight / 2 - deviation))
        model.lineTo((modelWidth / 2 - deviation), -(modelHeight / 2 - deviation))
        model.lineTo((modelWidth / 2 - deviation), (modelHeight / 2 - deviation))
        model.closePath();

        return model;
    }

    return (
        <>
            <mesh name='shape-1' position={[0, 0, 0.075]}>
                <extrudeGeometry args={[pattern_1_model(), extrudeSettings(0.15, 0.05, 0.1, 0, 1)]} />
                <meshStandardMaterial color={doorColor} side={THREE.DoubleSide}  toneMapped={false}/>
            </mesh>
            <mesh name='shape-2' position={[0, 0, 0.14]}>
                <extrudeGeometry args={[pattern_2_model(), extrudeSettings(0.01, 0.07, 0.07, 0, 1)]} />
                <meshStandardMaterial color={doorColor} side={THREE.DoubleSide}  toneMapped={false}/>
            </mesh>
            <mesh name='shape-3' position={[0, 0, 0.1]}>
                <extrudeGeometry args={[pattern_3_model(), extrudeSettings(0.09)]} />
                <meshStandardMaterial color={doorColor} side={THREE.DoubleSide}  toneMapped={false}/>
            </mesh>
            <mesh name='shape-4' position={[0, 0, 0.145]}>
                <extrudeGeometry args={[pattern_4_model(), extrudeSettings(0.01, 0.08, 0.08, 0, 1)]} />
                <meshStandardMaterial color={doorColor} side={THREE.DoubleSide}  toneMapped={false}/>
            </mesh>
            <mesh name='shape-5' position={[0, 0, 0.15]}>
                <extrudeGeometry args={[pattern_5_model(), extrudeSettings(0.01, 0.08, 0.08, 0, 1)]} />
                <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} metalness={0.03}  toneMapped={false}/>
            </mesh>
        </>
    )
}

export default PatternOneModel;